import { RouterProvider } from "react-router-dom";
import { router } from "./router/Router";
import { useRedirectAfterAuth } from "./hooks/useRedirectAfterAuth";
import { useHotjarScript } from "./hooks/useHotjarScript";

const AppRedirect = () => {
    useRedirectAfterAuth();
    return null;
};

const App = () => {
    useHotjarScript();

    return (
        <RouterProvider router={router}>
            <AppRedirect />
        </RouterProvider>
    );
};

export default App;
